import { ITreeStructure } from '../models/treeStructure'

export const deDupeTreeItems = (
  selectedItem: ITreeStructure,
  index: number,
  origin: ITreeStructure[]
) => origin.findIndex((it) => it.itemId === selectedItem.itemId) === index
